import React, { useState, useEffect, useRef } from "react";
import styles from "./RegistrationPage.module.css";
import signupImage from "../../assets/images/signupImage.png";
import { signupApi } from "../../config/signupApi";
import { loginApi } from "../../config/loginApi";
import { Link, useHistory} from "react-router-dom";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

import {connect} from 'react-redux';
import changeLogin from '../../store/Actions/LoginAction';

function RegistrationPage(props) {
  const [fullname, setFullname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const btn = useRef();

  const history = useHistory()

  const nameValidation = /^[a-zA-Z]+ [a-zA-Z]+ [a-zA-Z]+$/;
  const nameValidation2 = /^[a-zA-Z]+ [a-zA-Z]+$/;
  // const emailValidation = /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/;
  const emailValidation = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  // const passwordValidation = /^[A-Za-z[0-9]\w{7,}$/;
  const phoneValidation = /^(\+|\d)[0-9]{7,16}$/;

  const handleLogin = (e) => {
    e.preventDefault();

    const phonetest = phone.substring(1);
    if (
      nameValidation.test(fullname) === false &&
      nameValidation2.test(fullname) === false
    ) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Please Enter Valid Full Name!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (emailValidation.test(email) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{marginRight: "10px"}} />
          Please Enter Valid Email Address!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (
      // passwordValidation.test(password) === false
      !(password.length > 7 && password.length <21)  
    ) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{marginRight: "10px"}} />
          Please Enter Valid Password!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else if (phoneValidation.test(phonetest) === false) {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{marginRight: "10px"}} />
          Please Enter Valid Phone Number!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      setLoading(true);
      btn.current.setAttribute("disabled", "disabled");
      const first_name = fullname.split(" ").slice(0, -1).join(" ");
      const last_name = fullname.split(" ").slice(-1).join(" ");
      const signup = async () => {
        const signup = await signupApi(
          first_name,
          last_name,
          phone,
          email,
          password
        );

        if (signup.error) {
        
          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{marginRight: "10px"}} />
              {signup.error.response.data.message}
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );

          setLoading(false);
          btn.current.removeAttribute("disabled");
          
        } else if (signup.data) {
          
          const login = await loginApi(email, password);
          toast.success(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BsCheckAll size="30" style={{marginRight: "10px"}} />
              SignUp Successfully
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );

          setFullname("");
          setEmail("");
          setPassword("");
          setPhone("");

          setLoading(false);
          btn.current.removeAttribute("disabled");

          props.ChangeLogin(true)

          setTimeout(function(){
            history.push("/");
          },1000)
        }
      };
      signup();
    }
  };

  useEffect(() => {
    document.title = "VisaPro | Register";
  }, []);

  return (
    <div className={styles.mainall}>
      <div className={styles.main}>
        <img
          src={signupImage}
          alt="Main Image"
          className={styles.signupImage}
        />
        <div className={styles.formCont}>
          <h1 className={styles.heading}>Register</h1>
          <p className={styles.des}>Create Your Account</p>
          <form onSubmit={(e) => handleLogin(e)}>
            <input
              type="text"
              placeholder="Full Name"
              value={fullname}
              className={styles.input}
              onChange={(e) => setFullname(e.target.value)}
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              className={styles.input}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              className={styles.input}
              onChange={(e) => setPassword(e.target.value)}
            />

            <PhoneInput
              //   country={"ng"}
              containerClass={styles.inputPhone}
              inputClass={styles.phoneCont}
              buttonClass={styles.phoneButton}
              dropdownClass={styles.dropdownPhone}
              value={phone}
              placeholder="Phone"
              onChange={(e) => setPhone(`+${e}`)}
            />
            <button type="submit" className={styles.login} ref={btn}>
              {loading ? (
                <div class="spinner-border" role="status"></div>
              ) : (
                "Register"
              )}
            </button>
          </form>
          <div className={styles.allgo}>
            <p className={styles.next}>
              Existing customer?{" "}
              <Link to="/login" className={styles.go}>
                Sign in here
              </Link>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}



const mapStateToProps = (state) => ({
  login: state.Login.login,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
});

export default connect(mapStateToProps,mapDispatchToProp)(RegistrationPage);
